import { useEffect, useState } from 'react';

import exodus from '@/ui/exodus';

const DEFAULT_WALLET_ACCOUNT = 'exodus_0';

function useReceiveAddress({
  assetName,
  walletAccount = DEFAULT_WALLET_ACCOUNT,
}) {
  const [address, setAddress] = useState<string>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    exodus.addressProvider
      .getReceiveAddress({ assetName, walletAccount })
      .then((address) => {
        setAddress(address);
        setLoading(false);
      });
  }, [assetName, walletAccount]);

  return { address, loading };
}

export default useReceiveAddress;
